import Box from "@mui/material/Box";
import { SummaryRow } from "./SummaryRow";
import Typography from "@mui/material/Typography";
import { WarningMessage } from "./WarningMessage";
import { STYLES } from "./ShoppingCartStyles";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import {AppConfigFields} from "../../types/appConfigEntities";
import { numberFormatter } from "@ecommerce/shared-utils";
import { BUTTON_STYLES } from "../../styles/buttonStyles";
import { useTheme } from "../../util/themes";

interface SummarySectionProps {
  subtotal: number;
  shippingCost: number | null;
  total: number;
  productsDiscount?: number;
  shippingDiscount?: number;
  shippingOriginalCost?: number;
  isShippingToBeAgreed?: boolean;
  hasSelectedShippingOption: boolean;
  onCheckout: () => void;
  onViewMoreProducts: () => void;
}

export const SummarySection: React.FC<SummarySectionProps> = ({
  subtotal,
  shippingCost,
  total,
  productsDiscount = 0,
  shippingDiscount = 0,
  shippingOriginalCost,
  isShippingToBeAgreed,
  hasSelectedShippingOption,
  onCheckout,
  onViewMoreProducts
}) => {
  const theme = useTheme();
  const canCheckout = subtotal >= window.APP_CONFIG[AppConfigFields.MinimumPurchaseAmount];
  const hasShippingDiscount = shippingDiscount > 0;
  const originalShipping = shippingOriginalCost ?? shippingCost ?? 0;


  return (
    <Box sx={{ 
      position: 'sticky', 
      bottom: 0, 
      backgroundColor: theme.colors.background.paper,
      pt: 2,
      pb: 2,
    }}>
      <Divider sx={{mb: 1.5, borderColor: theme.colors.greyLight}}/>
      <SummaryRow label="Subtotal:" value={`${numberFormatter.toStringWithAmount(subtotal, '$')}`} />
      
      {productsDiscount > 0 && (
        <SummaryRow 
          label="Descuento:" 
          value={`- ${numberFormatter.toStringWithAmount(productsDiscount, '$')}`}
          valueStyle={{
            fontFamily: STYLES.fontFamily,
            fontSize: "14px",
            fontWeight: "bold",
            color: theme.colors.accent,
          }}
        />
      )}
      
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography
          sx={{
            fontFamily: STYLES.fontFamily,
            fontSize: "14px",
            fontWeight: "bold",
            color: theme.colors.text.primary,
          }}
        >
          Envío:
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {hasShippingDiscount && originalShipping > 0 && (
            <Typography
              sx={{
                fontFamily: STYLES.fontFamily,
                fontSize: "14px",
                fontWeight: "bold",
                color: theme.colors.text.secondary,
                textDecoration: 'line-through',
              }}
            >
              ${numberFormatter.toStringWithAmount(originalShipping)}
            </Typography>
          )}
          <Typography
              sx={{
                fontFamily: STYLES.fontFamily,
                fontSize: "14px",
                fontWeight: "bold",
                color: hasShippingDiscount ? theme.colors.accent : theme.colors.text.primary,
              }}
            >
              {!hasSelectedShippingOption
                ? "El costo se calcula más adelante"
                : isShippingToBeAgreed
                  ? "A convenir"
                  : shippingCost === 0
                    ? "Gratis"
                    : `$${numberFormatter.toStringWithAmount(shippingCost ?? 0)}`}
            </Typography>

        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, alignItems: 'center' }}>
        <Typography
          sx={{
            fontFamily: STYLES.fontFamily,
            fontSize: "22px",
            lineHeight: 1.4,
            color: theme.colors.text.primary,
          }}
        >
          Total:
        </Typography>
        <Typography
          sx={{
            fontFamily: STYLES.fontFamily,
            fontSize: "22px",
            lineHeight: 1.4,
            color: theme.colors.text.primary,
          }}
        >
          {numberFormatter.toStringWithAmount(total, '$')}
        </Typography>
      </Box>

      {/* Conditional rendering based on minimum purchase */}
      {canCheckout ? (
        <Button
          variant="contained"
          onClick={onCheckout}
          fullWidth
          sx={{
            ...BUTTON_STYLES.primary,
            width: '100%',
            mt: 2,
          }}
        >
          INICIAR COMPRA
        </Button>
      ) : (
        <WarningMessage message={`El monto mínimo de compra es de ${numberFormatter.toStringWithAmount(window.APP_CONFIG[AppConfigFields.MinimumPurchaseAmount], '$')} sin incluir el costo de envío`} />
      )}
      
      <Box sx={{ mt: canCheckout ? 2 : 0 }} textAlign={'center'}>
        <Button
          variant="text"
          onClick={onViewMoreProducts}
          sx={BUTTON_STYLES.text}
        >
          Ver más productos
        </Button>
      </Box>
    </Box>
  );
};














